module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"links":{"home":"Home","logout":"Log out","settings":"Settings","users":"Customers","user":"My Account"},"logout_alert":"Do you want to log out?"},"pt-BR":{"links":{"home":"Home","logout":"Sair","settings":"Configurações","users":"Clientes","user":"Minha Conta"},"logout_alert":"Deseja sair do sistema?"}}')
  delete Component.options._Ctor
}
